interface Props {
  title: string;
  description: string;
}

export default (props: Props) => {
  return (
    <View style={{ minWidth: 200 }}>
      <View as={'h4'} f={16}>
        {props.title}
      </View>
      <View f={14} c={'#999'}>
        {props.description}
      </View>
    </View>
  );
};
